export default "__VITE_ASSET__DsIvKu$E__"